// Reserved order guide names, to be compared lowercased with whitespace stripped.
// The backend reserves and rejects 'order guide' at the collection level and
// reserves and rejects the name 'default' at the partition level.
export const DEFAULT_COLLECTION_NAME = 'orderguide';
export const DEFAULT_PARTITION_NAME = 'default';
// This is a Sales Hub display rule, not a backend reserved name but should be reserved
// so that users don't see multiple 'Default Guides' named guides
export const SALES_HUB_DEFAULT_COLLECTION_LABEL = 'defaultguide';

const createNameValidator =
  (defaultName: string) => (name: string, groups: string[]) => {
    return (
      name.toLowerCase().replace(/\s/g, '') !== defaultName.toLowerCase() &&
      !groups.includes(name)
    );
  };

export const validateCollectionName = createNameValidator(
  DEFAULT_COLLECTION_NAME,
);

export const validatePartitionName = createNameValidator(
  DEFAULT_PARTITION_NAME,
);
